import { render, staticRenderFns } from "./DashboardApp.vue?vue&type=template&id=4631810f&scoped=true"
import script from "./DashboardApp.vue?vue&type=script&lang=js"
export * from "./DashboardApp.vue?vue&type=script&lang=js"
import style0 from "./DashboardApp.vue?vue&type=style&index=0&id=4631810f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4631810f",
  null
  
)

export default component.exports